import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Breadcrumbs, Card, CardContent, PageHeader } from "@/components/ui";
import { useAppStore } from "@/store";
import { useCreateLab } from "@/hooks/use-labs";
import { LabForm } from "@/components/labs/lab-form";

export const Route = createFileRoute("/_authenticated/labs/new")({
  component: NewLabPage,
});

function NewLabPage() {
  const { t } = useTranslation(["labs", "org"]);
  const navigate = useNavigate();
  const orgId = useAppStore((s) => s.activeOrgId);
  const createLab = useCreateLab(orgId);

  if (!orgId) {
    return (
      <div className="mx-auto max-w-4xl p-8">
        <p className="text-muted">{t("noOrgContext", { ns: "org" })}</p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl p-8">
      <Breadcrumbs items={[{ label: t("title"), to: "/labs" }, { label: t("addLab") }]} />
      <PageHeader title={t("addLab")} subtitle={t("subtitle")} />
      <Card className="mt-6">
        <CardContent>
          <LabForm
            submitting={createLab.isPending}
            errorMessage={
              createLab.isError && createLab.error instanceof Error
                ? createLab.error.message
                : undefined
            }
            onSubmit={async (payload) => {
              const lab = await createLab.mutateAsync(payload);
              if (lab) {
                void navigate({ to: "/labs/$labId", params: { labId: lab.id } });
              }
            }}
            onCancel={() => void navigate({ to: "/labs" })}
          />
        </CardContent>
      </Card>
    </div>
  );
}
